import axios from "axios";

const api = axios.create({
    // baseURL: 'https://localhost:44384/api/customer',
    // baseURL: "https://yiannis-stg-api.ginilytics.com:2000/api/customer",
    baseURL: "https://erp-api.ginilytics.com/api/customer",

    headers: {
        'Content-Type': 'application/json',
    }
});
api.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('accessToken');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

// export const imageURL = 'https://localhost:44384';
export const imageURL = 'https://erp-api.ginilytics.com';
// export const imageURL = 'https://yiannis-stg-api.ginilytics.com:2000';

// export const notificationURL = 'https://localhost:44384/notificationHub';
// export const notificationURL = 'https://yiannis-stg-api.ginilytics.com:2000/notificationHub';
export const notificationURL = 'https://erp-api.ginilytics.com/notificationHub';

// export const publishableKey = "pk_test_51RNob1LeLlNxdCvsU2DdKQzxdFnMopiP0Bcmdwej33H0LDDegWYX4hZ3Egrf9oetBzeFuV00fHh59mFpThnuXUz000NV0fyZ3D";
export const publishableKey = "pk_test_51RNobFPvgEUrbcEHUXdkPVQjDzYgaZ8Z0dWCJfm0lddb34EKDk9ycgM17p7Z5wi6IIggtj2S5iRGPpFhZl7GLOYr00NcrJNfTh";  //Demo

export default api;